<template>
  <div>
    <Card shadow>
      <Row :gutter="18">
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 50px">代理:</span>
            <Select
              v-model="table.params.app_id"
              filterable
              placeholder="筛选代理"
              @on-change="GetAppSmartList"
            >
              <Option
                v-for="(item, index) in app_list"
                :value="item.appid"
                :label="item.appName"
                :key="index"
              >
                {{ item.appName }}
                <span style="color: #bbb">({{ item.appid }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 120px">风控策略:</span>
            <Select
              v-model="table.params.smart_id"
              filterable
              clearable
              placeholder="筛选风控策略"
            >
              <Option
                v-for="(item, index) in select.exec_strategy_list"
                :value="item.smart_id"
                :label="item.name"
                :key="index"
              >
                {{ item.name }}
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 120px">玩家ID:</span>
            <Input
              v-model="table.params.user_id"
              placeholder="筛选玩家ID"
              style="width: 100%"
            />
          </label>
        </Col>
        <Col span="5">
          <label style="display: flex; align-items: center">
            <span style="width: 120px">筛选游戏:</span>
            <Select
              v-model="table.params.gid"
              filterable
              clearable
              placeholder="下拉筛选游戏"
            >
              <Option
                v-for="(item, index) in select.game_list"
                :value="item.game_id"
                :label="item.game_name"
                :key="index"
              >
                {{ item.game_name }}
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="5">
          <label style="display: flex; align-items: center">
            <span style="width: 160px">统计数据时间:</span>
            <DatePicker
              type="date"
              v-model="select.dataTime"
              placeholder="筛选统计数据时间"
              :options="gameDateOptions"
              @on-change="updateGameOptions"
            ></DatePicker>
          </label>
        </Col>
        <Col span="2" style="display: flex; justify-content: space-between">
          <Button type="primary" @click.native="GetAppUserGameInfo()"
            >查询</Button
          >
        </Col>
      </Row>
    </Card>
    <Table
      border
      :columns="table.columns"
      :data="table.data"
      :max-height="tableMaxHeight"
      style="margin-top: 12px"
    ></Table>
    <Page
      show-total
      show-sizer
      style="margin-top: 12px"
      :page-size="table.params.page_size"
      :total="table.total"
      :current="table.params.page"
      @on-change="ChangePage"
      @on-page-size-change="ChangePageSize"
    />
  </div>
</template>
<script>
import {
  GetAppSmartList,
  GetAppUserGameInfo,
  GetAllGameList
} from '@/api/admin/risk'
import moment from 'moment'
export default {
  name: 'gameRiskData',
  data() {
    return {
      tableMaxHeight: 0,
      select: {
        exec_strategy_list: [], //执行策略列表
        cur_exec_strategy_list: [],
        game_list: [], //游戏列表
        dataTime: new Date(moment(0, 'HH').format('YYYY-MM-DD HH:mm:ss'))
      },
      today: new Date(moment(new Date()).format('YYYY-MM-DD')).getTime(),
      gameDateOptions: {
        disabledDate: val => {
          let date = new Date(val).getTime()
          return date > this.today
        }
      },
      table: {
        params: {
          platid: 0,
          gid: 0, //所选择得游戏
          uid: null,
          smart_id: 0, //所选择执行策略
          app_id: 0, //所选择分组
          stime: 0,
          etime: 0,
          page: 1,
          page_size: 10
        },
        total: 0,
        page: 1,
        data: [],
        columns: [
          {
            type: 'index',
            title: '序号',
            width: 60,
            align: 'center'
          },
          {
            key: 'app_name',
            align: 'center',
            width: 200,
            resizable: true,
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                '所属盘口',
                '显示该玩家所属盘口；显示盘口APP名称'
              )
          },
          {
            key: 'uid',
            align: 'center',
            width: 200,
            resizable: true,
            renderHeader: (h, params) =>
              this.renderHeader(h, '玩家ID', '显示玩家的UID')
          },
          {
            key: 'nick_name',
            align: 'center',
            width: 200,
            resizable: true,
            renderHeader: (h, params) =>
              this.renderHeader(h, '玩家昵称', '显示玩家的昵称')
          },
          {
            key: 'game_name',
            align: 'center',
            width: 200,
            resizable: true,
            renderHeader: (h, params) =>
              this.renderHeader(h, '游戏', '显示该的对局游戏')
          },
          {
            key: 'rule',
            align: 'center',
            width: 200,
            resizable: true,
            renderHeader: (h, params) =>
              this.renderHeader(h, '房间', '显示该对局发生时所在游戏的房间')
          },
          {
            key: 'bet',
            align: 'center',
            width: 200,
            resizable: true,
            render: (h, params) =>
              h('span', this.getCustomFixed(params.row.bet / 10000)),
            renderHeader: (h, params) => {
              return this.renderHeader(h, '投注', '显示该局游戏的投注金额')
            }
          },
          {
            key: 'hit',
            align: 'center',
            width: 200,
            resizable: true,
            render: (h, params) =>
              h('span', this.getCustomFixed(params.row.hit / 10000)),
            renderHeader: (h, params) => {
              return this.renderHeader(h, '返奖', '显示该局游戏的返奖金额')
            }
          },
          {
            key: 'itime',
            align: 'center',
            width: 200,
            resizable: true,
            renderHeader: (h, params) => {
              return this.renderHeader(h, '时间', '显示该局结算的时间')
            }
          },
          {
            key: 'smart_id',
            align: 'center',
            minWidth: 200,
            render: (h, params) => {
              let item = this.select.cur_exec_strategy_list.find(
                el => el.smart_id == params.row.smart_id
              )
              return h('span', item ? item.name : '')
            },
            renderHeader: (h, params) => {
              return this.renderHeader(h, '风控策略', '显示该局被应用的风控')
            }
          }
        ],
        pageSizes: [10, 20, 30, 40]
      },
      ChannelMoney_Modal: {
        show: false,
        data: {},
        type: 0
      }
    }
  },
  methods: {
    GetAllGameList() {
      return new Promise((resolve, reject) => {
        GetAllGameList({
          gtype: 0,
          page: 1,
          page_size: 10000
        }).then(res => {
          // let other = 0;
          // let arr = ['抢庄牛牛', '炸金花', '捕鱼大战', '3D捕鱼', '红包扫雷', '21点', '龙虎斗', '金蟾捕鱼', '德州扑克', '斗地主', '万人炸金花', '红黑大战', '二人麻将', '古惑仔', '澳门风云', '飞禽走兽', '跑马水果机', '百家乐', '多福多财', '疯狂牛牛', '骰宝', '百人金花牛', '百人牛牛', '二人牛牛', '翻倍血流', '奔驰宝马', '鱼虾蟹'];
          // let str = res._param.data.reduce((res, cur) => {

          //     let index = arr.findIndex((el) => el == cur.game_name);
          //     if (index == -1) {
          //         index = arr.length + other;
          //         other++;
          //     }
          //     res += `'${cur.game_id}':${index},`;

          //     return res;
          // }, '');
          // str = `{${str}}`;
          // console.log(str)
          this.select.game_list = res._param.data || []
          resolve()
        })
      })
    },
    ChangePage(page) {
      this.table.params.page = page
      this.GetAppUserGameInfo()
    },
    ChangePageSize(page_size) {
      this.table.params.page = 1
      this.table.params.page_size = page_size
      this.GetAppUserGameInfo()
    },
    getPlatId(appid) {
      let item = this.app_list.find(el => el.appid == appid)
      return item ? item.platform : 0
    },
    async GetAppSmartList(val) {
      this.select.exec_strategy_list = []
      this.table.params.smart_id = 0
      let app_id = this.table.params.app_id
      if (app_id) {
        let params = {
          app_id,
          platid: this.getPlatId(app_id)
        }
        await GetAppSmartList(params).then(res => {
          this.select.exec_strategy_list = res._param.data || []
        })
      }
    },
    GetAppUserGameInfo() {
      this.table.data = []
      this.table.total = 0
      this.select.cur_exec_strategy_list = [...this.select.exec_strategy_list]
      if (this.table.params.app_id) {
        let app_id = this.table.params.app_id
        let platid = this.getPlatId(app_id)
        this.table.params.stime = this.getSecond(this.select.dataTime)
        this.table.params.etime = this.getSecond(this.select.dataTime, false)
        let param = this.copyData(Object.assign(this.table.params, { platid }))
        param.uid = param.uid || 0
        GetAppUserGameInfo(param).then(res => {
          this.table.total = res._param.total
          this.table.data = res._param.data
        })
      }
    },
    updateGameOptions(val) {},
    async initFunc() {
      let item = this.app_list[0]
      this.table.params.app_id = item.appid
      await this.GetAppSmartList()
      this.GetAppUserGameInfo()
    }
  },

  created() {
    this.initFunc()
    this.GetAllGameList()
  },
  mounted() {
    this.tableMaxHeight = window.document.body.clientHeight - 270
  }
}
</script>
<style lang="less" scoped>
.btn_batch {
  margin-right: 12px;
}
</style>
